import { render, staticRenderFns } from "./DesignPreviewModal.vue?vue&type=template&id=ebc7fec8&scoped=true"
import script from "./DesignPreviewModal.vue?vue&type=script&lang=ts"
export * from "./DesignPreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc7fec8",
  null
  
)

export default component.exports